export const INCIDENT_LIST_QUERY_KEY = 'incident-list'
